import React, { forwardRef } from 'react';
import { useSnackbar, SnackbarContent, CustomContentProps } from "notistack";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const ApiError = forwardRef<HTMLDivElement, CustomContentProps>(
    ({ id, ...props }, ref) => {
        const { closeSnackbar } = useSnackbar();

        const onClose = () => {
            closeSnackbar(id);
        };

        return (
            <SnackbarContent ref={ref}>
                <Alert
                    severity="warning"
                    sx={{ alignItems: 'center' }}
                    action={
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                >
                    <Stack direction="row" spacing={1} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body1">
                            {props.message}
                        </Typography>
                    </Stack>
                </Alert>
            </SnackbarContent>
        );
    }
);

export default ApiError;